module.exports = __webpack_public_path__ + "img/pic_gg@2x.fb5cfa70.png";